module.exports = __webpack_public_path__ + "img/20_73.56e936b1.png";